var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/Attribute.ts";
import * as t from 'io-ts';
export var Attribute = t.type({
  id: t.number,
  valueIds: t.array(t.number)
});